import React from 'react'

import styles from './Footer.module.css'

const Footer = () => (
  <div className={styles.wrapper}>
    <div className={styles.inner}>
      <div className={styles.logo}>
        <img src='/assets/images/logo-plurall.png' alt='Plurall' />
      </div>
      <div className={styles.text}>
        Direitos Autorais © {new Date().getFullYear()}, SOMOS Educação S.A. <br />
        Todos os direitos reservados.
      </div>
    </div>
  </div>
)

export default Footer
